import _classCallCheck from "/Users/professor/WebstormProjects/string_table_converter/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";

/**
 * -------------------------------------------------------------------------------------------
 * Copyright (c) Microsoft Corporation.  All Rights Reserved.  Licensed under the MIT License.
 * See License in the project root for license information.
 * -------------------------------------------------------------------------------------------
 */

/**
 * @class
 * @implements MiddlewareOptions
 * Class representing AuthenticationHandlerOptions
 */
export var AuthenticationHandlerOptions =
/**
 * @public
 * @constructor
 * To create an instance of AuthenticationHandlerOptions
 * @param {AuthenticationProvider} [authenticationProvider] - The authentication provider instance
 * @param {AuthenticationProviderOptions} [authenticationProviderOptions] - The authentication provider options instance
 * @returns An instance of AuthenticationHandlerOptions
 */
function AuthenticationHandlerOptions(authenticationProvider, authenticationProviderOptions) {
  _classCallCheck(this, AuthenticationHandlerOptions);

  this.authenticationProvider = authenticationProvider;
  this.authenticationProviderOptions = authenticationProviderOptions;
};